import React, { useEffect } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useScroll } from "../hooks";
import ProductListItem from "./ProductListItem";

const ProductListGroup = ({
  showTitle,
  items,
  index,
  group,
  executeScroll,
  onView,
  onSelected,
  onProductChange
}) => {
  const [scroll, elementToScrollRef] = useScroll(70);

  useEffect(() => {
    if (executeScroll) {
      scroll();
    }
  }, [executeScroll, scroll]);

  useScrollPosition(
    ({ _, currPos }) => {
      if (currPos.y > 0 && currPos.y < window.innerHeight / 4) {
        onView(index);
      }
    },
    [],
    elementToScrollRef
  );

  return (
    <div ref={elementToScrollRef} className="product-group mb-4">
      <Typography className="mb-3" variant="h6">
        {showTitle ? group.label : " "}
      </Typography>

      <Grid container spacing={2}>
        {group.products.map((product, i) => {
          let quantity = 0;
          let itemIndex = null;

          items.forEach((item, i) => {
            if (item.productID === product.id) {
              quantity += item.quantity;
              itemIndex = i;
            }
          });

          return (
            <Grid key={`product-group-${i}`} item xs={12} sm={6} lg={items.length > 0 ? 6 : 4}>
              <ProductListItem
                key={`product-${i}`}
                index={itemIndex}
                product={product}
                quantity={quantity}
                onSelected={onSelected}
                onChange={onProductChange}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default ProductListGroup;
